module.exports = __webpack_public_path__ + "img/ico_upload_active.c5403404.svg";